import React from "react";
import Section from "./Section";
import ContactContent from "./NotificationContent";
import { Helmet } from 'react-helmet-async';
import { useEffect } from "react";
import { scrollWindow } from "../../helpers/common";

const Notifications = () => {
  useEffect(() => {
    scrollWindow()
   }, []);
 
  return (
    <React.Fragment>
      <Helmet>
        <title>Notifications | Jobseekers Page </title>
      </Helmet>
      <Section />

      <ContactContent />
    </React.Fragment>
  );
};

export default Notifications;
